import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import ExternalButton from '../../components/ExternalButton/ExternalButton';
import { FirebaseHelper } from '../../firebase-helper';
import PostsSection from '../../Sections/PostsSection/PostsSection'
import WallpapersSection from '../../Sections/WallpapersSection/WallpapersSection'
import './HomePage.scss'

import linkedinIcon from '../../assets/Images/linkedin-logo.png';
import githubIcon from '../../assets/Images/github-logo.png';
import youtubeIcon from '../../assets/Images/youtube-logo.webp';
import YoutubeListsSection from '../../Sections/YoutubeListsSection/YoutubeListsSection';
import Image from '../../components/Image/Image';

function HomePage(props) {

  return (
    <div className='home-page container'>
      <div className='background'>
        <Image path="Wallpapers" id={props.wallpapers[Math.floor(Math.random() * props.wallpapers.length)].id } type=""/>
      </div>
      <WallpapersSection wallpapers={props.wallpapers} />
      <div className='post-portfolio-row'>
        <div className='post-section-container'>
          <PostsSection posts={props.posts} />
          <div className='youtube-lists-container'>
            <YoutubeListsSection/>
          </div>
        </div>
        <div className='portfolio-container'>
          <div className='portfolio'>
            <div className='portfolio-image'>
              <img src='https://media-exp1.licdn.com/dms/image/C4D03AQFCphbKvnVRaw/profile-displayphoto-shrink_400_400/0/1655317275383?e=1660780800&v=beta&t=jLdLFJcAVyfjTbOT5lk-fcyB6aXKy6Lv4VMWRoA9nDg' />
            </div>

            <div className='portfolio-title'>HARUNLUK</div>
            <div className='portfolio-description'> Software Engineer</div>
            <div className='portfolio-links'>
              harunserli@gmail.com
              <div className='link-buttons'>
                <ExternalButton url="https://www.linkedin.com/in/harunluk/">
                  <img src={linkedinIcon} />
                </ExternalButton>
                <ExternalButton url="https://github.com/HARUNLUK">
                  <img src={githubIcon} />
                </ExternalButton>
                <ExternalButton url="https://www.youtube.com/channel/UCacyf_eXIR0w_95dvzoOmdg/playlists">
                  <img src={youtubeIcon} />
                </ExternalButton>
              </div>
            </div>
          </div>
        </div>

      </div>




    </div>
  )
}

export default HomePage